import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center position-relative" }
const _hoisted_4 = { class: "position-absolute top-50 end-0 translate-middle-y saas-chart-position" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1 me-3" }, [
          _createElementVNode("span", { class: "d-block mb-2" }, "Active User"),
          _createElementVNode("h3", { class: "fs-24 fw-bold" }, "241K"),
          _createElementVNode("span", { class: "bg-success bg-opacity-10 border border-success rounded-pill text-success px-2 fs-12 fw-medium d-inline-block" }, " +5.4% ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                style: {"width":"95px"},
                type: "donut",
                height: "85",
                options: _ctx.activeUser,
                series: _ctx.users
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}